'use strict';

module.exports = /* @ngInject */ function () {
    return {
        restrict: 'E',
        scope: {
            group: '=',
            childrenByParent: '=',
            childrenLoading: '=',
            isOpen: '&',
            hasChildrenLoaded: '&',
            toggleNode: '&',
            select: '&',
        },
        templateUrl: `./${BUILD_PATH}/material-group-tree-node.template.html`,
    };
};
